import { Component, computed, input } from '@angular/core';
import { NgStyle } from '@angular/common';

export type ChevronDirection =
  | 'up' | 'right' | 'down' | 'left'
  | 'bottom-right' | 'bottom-left' | 'top-right' | 'top-left';

@Component({
  standalone: true,
  selector: 'app-chevron-right',
  imports: [NgStyle],
  templateUrl: './chevron-right.html',
  styleUrl: './chevron-right.scss',
})
export class ChevronRight {
  stroke = input('#797674');
  width = input('1rem');
  height = input('1rem');
  direction = input<ChevronDirection>('right');

  rotation = computed(() => {
    switch (this.direction()) {
      case 'right':        return 0;
      case 'bottom-right': return 45;
      case 'down':         return 90;
      case 'bottom-left':  return 135;
      case 'left':         return 180;
      case 'top-left':     return 225;
      case 'up':           return 270;
      case 'top-right':    return 315;
      default:             return 0;
    }
  });
}
